import type { AngleSectionType } from "../interfaces/AngleSectionType";
import type { CornerBraceType } from "../interfaces/CornerBrace";
import type { CornerType } from "../interfaces/CornerType";
import type { DishType } from "../interfaces/DishType";
import type { FootType } from "../interfaces/FootType";
import type { HandleType } from "../interfaces/HandleType";
import type { HingeType } from "../interfaces/HingeType";
import type { LockType } from "../interfaces/LockType";
import type { PaddingType } from "../interfaces/Padding";
import type { PanelColor } from "../interfaces/PanelColor";
import type { PanelStrength } from "../interfaces/PanelStrength";
import type { PianoHingeType } from "../interfaces/PianoHingeType";
import type { ProfileType } from "../interfaces/ProfileType";
import type { RackRailType } from "../interfaces/RackRailType";
import type { RollerType } from "../interfaces/RollerBoardProperties";
import type { RunnerType } from "../interfaces/RunnerType";
import type { TrayMaterialType } from "../interfaces/TrayMaterialType";
import type { TrolleyHandleType } from "../interfaces/TrolleyHandleType";

export enum LTCaseUserOption {
  AngleSectionType = "AngleSectionType",
  CornerType = "CornerType",
  CornerBraceType = "CornerBraceType",
  DishType = "DishType",
  FootType = "FootType",
  HandleType = "HandleType",
  HingeType = "HingeType",
  LockType = "LockType",
  PianoHingeType = "PianoHingeType",
  PaddingType = "PaddingType",
  PanelColor = "PanelColor",
  PanelStrength = "PanelStrength",
  ProfileType = "ProfileType",
  RackRailType = "RackTailType",
  RollerType = "RollerType",
  RunnerType = "RunnerType",
  TrayMaterialType = "TrayMaterial",
  TrolleyHandleType = "TrolleyHandleType",
}

export type LTCaseUserOptionTypeMap = {
  [LTCaseUserOption.PanelColor]: PanelColor;
  [LTCaseUserOption.ProfileType]: ProfileType;
  [LTCaseUserOption.CornerType]: CornerType;
  [LTCaseUserOption.CornerBraceType]: CornerBraceType;
  [LTCaseUserOption.RollerType]: RollerType;
  [LTCaseUserOption.AngleSectionType]: AngleSectionType;
  [LTCaseUserOption.PanelStrength]: PanelStrength;
  [LTCaseUserOption.DishType]: DishType;
  [LTCaseUserOption.FootType]: FootType;
  [LTCaseUserOption.HandleType]: HandleType;
  [LTCaseUserOption.HingeType]: HingeType;
  [LTCaseUserOption.LockType]: LockType;
  [LTCaseUserOption.PianoHingeType]: PianoHingeType;
  [LTCaseUserOption.PaddingType]: PaddingType;
  [LTCaseUserOption.RackRailType]: RackRailType;
  [LTCaseUserOption.RunnerType]: RunnerType;
  [LTCaseUserOption.TrayMaterialType]: TrayMaterialType;
  [LTCaseUserOption.TrolleyHandleType]: TrolleyHandleType;
};

export const LTCaseUserOptionTranslationMap: Record<LTCaseUserOption, string> =
  {
    [LTCaseUserOption.PanelColor]: "Holzfarben",
    [LTCaseUserOption.ProfileType]: "Schlieẞprofile",
    [LTCaseUserOption.CornerType]: "Ecken",
    [LTCaseUserOption.CornerBraceType]: "L-Ecken",
    [LTCaseUserOption.RollerType]: "Rollen",
    [LTCaseUserOption.AngleSectionType]: "Kantenschutz",
    [LTCaseUserOption.PanelStrength]: "Holzstärken",
    [LTCaseUserOption.DishType]: "Plaketten",
    [LTCaseUserOption.FootType]: "Füẞe",
    [LTCaseUserOption.HandleType]: "Griffe",
    [LTCaseUserOption.HingeType]: "Scharniere",
    [LTCaseUserOption.LockType]: "Schlösser",
    [LTCaseUserOption.PianoHingeType]: "Klavierband",
    [LTCaseUserOption.PaddingType]: "Schaumstoffe",
    [LTCaseUserOption.RackRailType]: "Rackschienen",
    [LTCaseUserOption.RunnerType]: "Rutschleisten",
    [LTCaseUserOption.TrayMaterialType]: "Trennbretter",
    [LTCaseUserOption.TrolleyHandleType]: "Ausziehgriffe",
  };
